import {NolimitPromotionPlugin} from "@nolimitcity/promo-panel/bin/NolimitPromotionPlugin";
import {PromoPanelGameConfiguration} from "@nolimitcity/promo-panel/bin/interfaces/ASInterfaces";
import {BenjiKIV} from "./BenjiKIV";
import {BenjiKIVXBetView} from "./view/general/BenjiKIVXBetView";

export class BenjiKIVPromotionPlugin extends NolimitPromotionPlugin{
    constructor(config?:PromoPanelGameConfiguration) {
        super(config);
    }
    close(isFeatureBuy?: boolean, isFreeBetTriggered?: boolean):void{
        super.close(isFeatureBuy,isFreeBetTriggered);
        BenjiKIV.overlayScatterView.deActivateBoostedOverlays(true);
        if(BenjiKIV.apiPlugin.freeBets.hasFreeBets() || BenjiKIV.apiPlugin.freeFeatureBet.hasFreeFeatureBet()){
            BenjiKIV.xBetView.enableButtons(false);
            BenjiKIV.xBetView.turnOffBoost(true);
            BenjiKIV.xBetView.hide();
            return;
        }
        if(BenjiKIV.apiPlugin.betHandler.betBoost){
            if(BenjiKIV.apiPlugin.betHandler.betBoost.featureName===BenjiKIVXBetView.BOOST_BET_1){
                // BenjiKIV.xBetView.level01Toggle();
                BenjiKIV.xBetView.turnOnxBet1();
            }else {
                // BenjiKIV.xBetView.level02Toggle();
                BenjiKIV.xBetView.turnOnXbetLevel2();
            }
        }else {
            BenjiKIV.xBetView.turnOffBoost(false);
        }
    }

}